import { Observable } from "rxjs";

import st from "lib/utils/index";
import { CompanyRepository } from "lib/repositories/index";
import { createFormInstance } from "modules/utils/index";
import { fetchCurrentCompany } from "modules/auth";

export const INITIALIZE_VIEW = "settings/ProductsSettingsView/INITIALIZE_VIEW";
export const INITIALIZE_MODEL = "settings/ProductsSettingsView/INITIALIZE_MODEL";
export const UPDATE_MODEL = "settings/ProductsSettingsView/UPDATE_MODEL";
export const VALIDATE = "settings/ProductsSettingsView/VALIDATE";
export const SUBMIT = "settings/ProductsSettingsView/SUBMIT";
export const FETCH_SUBMIT_START = "settings/ProductsSettingsView/FETCH_SUBMIT_START";
export const FETCH_SUBMIT_SUCCESS = "settings/ProductsSettingsView/FETCH_SUBMIT_SUCCESS";
export const FETCH_SUBMIT_FAILURE = "settings/ProductsSettingsView/FETCH_SUBMIT_FAILURE";

export const stateSelector = (state) => state.settings.ProductsSettingsView;

const formInstance = createFormInstance({
  INITIALIZE_MODEL,
  UPDATE_MODEL,
  VALIDATE,
  SUBMIT,
  FETCH_SUBMIT_START,
  FETCH_SUBMIT_SUCCESS,
  FETCH_SUBMIT_FAILURE,
  stateSelector,
  // validate: ({ form: { model } }, errors) => {
  //   errors.add(`model.default_product_price_currency`, st.validators.presence(model.default_product_price_currency))
  // },
  submitModel: ({ form: { initialModel, model } }) => {
    const serialize = (company) => ({
      id: company.id,
      general_terms: company.general_terms,
      accepts_printed_customer_vouchers: company.accepts_printed_customer_vouchers,
      default_products_enable_frontend_slots_listing: false,
    });
    return CompanyRepository.update(serialize(model), serialize(initialModel));
  },
});

const initialState = {
  form: formInstance.initialState,
};

const reducers = {
  ...formInstance.reducersMap,

  [INITIALIZE_VIEW]: () => initialState,
};

const epics = [
  ...formInstance.epics,

  (actions$, { getState }) =>
    actions$.ofType(INITIALIZE_VIEW).map(() => {
      const company = getState().auth.company.model;
      return initializeModel(company);
    }),

  (actions$) => actions$.ofType(FETCH_SUBMIT_SUCCESS).mapTo(fetchCurrentCompany()),
];

export function initializeView() {
  return { type: INITIALIZE_VIEW };
}

export const { initializeModel, updateModel, validate, submit } = formInstance.actions;

export default st.duck.createDuck(initialState, reducers, epics);



// WEBPACK FOOTER //
// ./src/modules/settings/ProductsSettingsView/index.js